import { LogosBlockSettings } from "../LogosProps.interface";

import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default (blockSettings: LogosBlockSettings): any => {
    const settings = useSelector(state => state.settings.content);
    const elementRef = useRef<any>(null);

    useEffect(() => {
        if (elementRef.current && settings) {
            // Background color from block

            if (blockSettings?.backgroundColor) {
                elementRef.current.style.setProperty("--background-color", blockSettings.backgroundColor);
            }

            if (typeof (blockSettings.borderColor) !== "undefined") {
                elementRef.current.style.setProperty("--logos-border-color", blockSettings.borderColor);
            }

            if (typeof (blockSettings.hoverBackgroundColor) !== "undefined") {
                elementRef.current.style.setProperty("--logos-hover-color", blockSettings.hoverBackgroundColor);
            }

            if (typeof (blockSettings.primaryBackgroundColor) !== "undefined") {
                elementRef.current.style.setProperty("--logos-primary-color", blockSettings.primaryBackgroundColor);
            }
            else if (typeof (settings?.theme?.primaryColor) !== "undefined") {
                elementRef.current.style.setProperty("--logos-primary-color", settings?.theme?.primaryColor);
            }

            if (typeof (blockSettings.secondaryBackgroundColor) !== "undefined") {
                elementRef.current.style.setProperty("--logos-secondary-color", blockSettings.secondaryBackgroundColor);
            }
            else if (typeof (settings?.theme?.secondaryColor) !== "undefined") {
                elementRef.current.style.setProperty("--logos-secondary-color", settings?.theme?.secondaryColor);
            }
        }
    }, [elementRef, settings]);

    return elementRef;
};